export default "__VITE_ASSET__DaCagPtS__"